import { SessionStore } from '../../constants/sessionStore';
import axios from '../../common/utils/interceptor';
import { ValidateAssessmentLaunchConfig, ValidateAssessmentPayload } from '../../assessment/interfaces';
import { apiUrls } from '../../constants/apiUrls';

// Create dummy session
const createDummySession = async (): Promise<void> => {
  const { data } = await axios.post(apiUrls.DUMMY_CANDIDATE_SIGNUP, {});

  if (data.sessionId) sessionStorage.setItem(SessionStore.dummyCandidate, '1');
};

/** validate url */
export const validateAssessmentLaunchUrl = async (
  launchConfig: ValidateAssessmentLaunchConfig,
): Promise<{ error: boolean }> => {
  const res = {
    error: false,
  };

  try {
    const pathname = window.location.href;
    const isQuiz = pathname.includes('quiz');
    const userSessionActive = sessionStorage.getItem(SessionStore.userSessionActive) === 'true';
    const dummyCandidate = sessionStorage.getItem(SessionStore.dummyCandidate) === '1';

    // If current item is quiz make dummy user session
    if (isQuiz && !userSessionActive && !dummyCandidate) {
      await createDummySession();
    }

    await axios.post(apiUrls.POST_VALIDATE_ASSESSMENT_LAUNCH, launchConfig);
  } catch (e) {
    console.error('Validate Assessment error: ', e);
    res.error = true;
  }
  return res;
};

export const validateAssessment = async (
  payload: ValidateAssessmentPayload,
): Promise<{ data: { token: string }; error: boolean }> => {
  const response = { data: { token: '' }, error: false };
  try {
    const { data } = await axios.post(apiUrls.POST_VALIDATE_ASSESSMENT, payload);
    response.data = data;
  } catch (e) {
    response.error = true;
  }
  return response;
};
